import { useContactModal } from '../context/ContactModalContext';

const ContactTrigger = ({ children, className, ...props }) => {
  const { openContact } = useContactModal();

  return (
    <button
      type="button"
      className={className}
      onClick={openContact}
      {...props}
    >
      {children}
    </button>
  );
};

export default ContactTrigger;
